export default function renderPenname(pennames = []) {
  if (!pennames || pennames.length === 0) {
    return "";
  }

  const htmlPenname = pennames.map((pn, index) => {
    return `${pn.label}`;
  });

  return htmlPenname.join(", ");
}
